import { render, staticRenderFns } from "./OrderListView.vue?vue&type=template&id=32e847c4&"
import script from "./OrderListView.vue?vue&type=script&lang=js&"
export * from "./OrderListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports